import React, {useState} from 'react'

import {callAPI} from '../hooks/api'
import {toast} from 'react-toastify'
import Spinner from './Spinner'

export default function AdminAddUserCardView() {
  const [loading, setLoading] = useState(false)

  const [valueChanged, setValueChanged] = useState(false)
  const [sendEmail, setSendEmail] = useState(false)

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    companyName: '',
    tier: 'Advanced',
  })

  const { firstName, lastName, email, companyName, tier } = formData

  function onChange(e) {
    setValueChanged(true)
    setFormData((prevState) => ({
      ...prevState,
      [e.target.id]: e.target.value,
    }))
  }

  // Define the tiers available for add.
  const tiers = {
    Basic: 'Basic (Free)',
    // Essential: 'Essential ($19 / mo)',
    // 'Essential-annual': 'Essential ($182 / yr)',
    Advanced: 'Advanced ($10 / mo)',
    'Advanced-annual': 'Advanced ($96 / yr)',
    Professional: 'Professional ($100 / mo)',
    'Professional-annual': 'Professional ($960 / yr)',
  }


  const handleTierChange = (e) => {
    e.preventDefault(e)
    setFormData((prevState) => ({
      ...prevState,
      ['tier']: e.target.value,
    }))
  }

  async function onAdd() {
    try {
      if (!firstName || !lastName || !email || !tier) {
        toast.warn('Please fill out all the information.')
        return
      }

      setLoading(true)
      var endpoint = '/create_new_user'
      var params = {
        firstname: firstName,
        lastname: lastName,
        companyname: companyName,
        tier: tier,
        email: email,
        sendEmail: sendEmail,
      }
      callAPI(endpoint, params).then((res) => {
        setLoading(false)
        if (res.status === ' success') {
          toast.success(res.msg)
        } else {
          toast.warn(res.msg)
        }
        setValueChanged(false)
      })
    } catch (error) {
      setLoading(false)
      toast.warn(error.message)
    }
  }

  function onSendEmailChange(e) {
    setSendEmail(e.target.checked)
  }

  if (loading) {
    return <Spinner local={true} />
  }
  return (
    <>
      <div className="w-full flex items-center justify-between text-black text-m font-medium rounded transition duration-150 ease-in-out mt-2 mb-2 p-6">
        <div>New User</div>
        <div className="flex space-x-4">
          <button
            onClick={onAdd}
            className={`${valueChanged ? 'bg-[#007377] hover:bg-[#01589d] focus:bg-[#01589d] cursor-pointer' : 'bg-gray-600 hover:bg-gray-700 focus:bg-gray-700 cursor-not-allowed'} text-white font-medium text-sm rounded shadow-md hover:shadow-lg focus:shadow-lg w-[270px] text-center transition duration-150 ease-in-out`}
            disabled={!valueChanged}
          >
            Add
          </button>
        </div>
      </div>

      <form onSubmit={() => {}}>
        <div>
          <input
            className="mb-2 w-[49%] px-4 py-2 text-base text-gray-700 bg-white border-gray-300 rounded transition ease-in-out"
            type="text"
            id="firstName"
            value={firstName}
            onChange={onChange}
            placeholder="First Name"
          />
          <input
            className="ml-[2%] mb-2 w-[49%] px-4 py-2 text-base text-gray-700 bg-white border-gray-300 rounded transition ease-in-out"
            type="text"
            id="lastName"
            value={lastName}
            onChange={onChange}
            placeholder="Last Name"
          />
        </div>
        <div className="flex items-center mb-2">
          <input
            className="w-[75%] px-4 py-2 text-base text-gray-700 bg-white border-gray-300 rounded transition ease-in-out"
            type="email"
            id="email"
            value={email}
            onChange={onChange}
            placeholder="Email"
          />
          <div className="ml-2 flex items-center">
            <input
              type="checkbox"
              id="sendEmail"
              className="mr-1"
              onChange={onSendEmailChange}
            />
            <label htmlFor="sendEmail" className="text-base text-gray-700">
              Send email to the user
            </label>
          </div>
        </div>
        <input
          className="mb-2 w-full px-4 py-2 text-base text-gray-700 bg-white border-gray-300 rounded transition ease-in-out"
          type="text"
          id="companyName"
          value={companyName}
          onChange={onChange}
          placeholder="Company Name (Optional)"
        />
        <select
          value={tier}
          className="mb-2 w-full px-4 py-2 text-base text-gray-700 bg-white border-gray-300 rounded transition ease-in-out"
          onChange={handleTierChange}
        >
          {Object.entries(tiers).map(([key, value]) => (
            <option key={key} value={key}>
              {value}
            </option>
          ))}
        </select>
        <div className="flex justify-between whitespace-nowrap text-sm sm:text-lg">
          <p className="mb-2"></p>
        </div>
      </form>
    </>
  )
}
